import request from '@/utils/request'

export function GetPage(data) {
    return request({
        url: '/api/Script/GetPage',
        method: 'get',
        params: data
    })
}

export function SetScriptStatus(data) {
    return request({
        url: '/api/Script/SetScriptStatus',
        method: 'get',
        params: data
    })
}



